<template>
  <div class="dropdown"
       :class="{ 'dropdown_disabled': disabled}"
       ref="dropdown"
       @click="click">
    <button type="button"
            :class="buttonWrapperClass">

      <div class="dropdown-btn btn-extra-round"
           ref="button"
           :class="classes"
           :style="styles">

          <img v-if="dataImage"
              :src="dataImage.imgSrc"
              :alt="dataImage.imgAlt"
              class="dropdown-img">

          <p v-if="dataTitle"
            class="dropdown-title">{{dataTitle}}</p>          

        <i v-if="!noControl"
           class="mdi dropdown-icon"
           ref="icon"
           v-tooltip="val ? 'Limpar' : null"
           :class="icon"
           @click="clear"></i>

      </div>

    </button>

    <div v-show="!hidden"
         class="dropdown-menu"
         :style="menuStyles"
         ref="body"
         @click="evt => evt.stopPropagation()">

      <h3 class="text-bold"
          v-if="dataMenuHeading">{{dataMenuHeading}}</h3>

      <slot></slot>
    </div>
  </div>
</template>

<script>
import vModel from "@mixins/v-model";
import dropdownMenuProps from "@mixins/dropdown/dropdown-menu-props";
import dropdownButtonProps from "@mixins/dropdown/dropdown-button-props";

export default {
  data() {
    return {
      hidden: true,
    };
  },

  props: {
    dataFontSize: {
      type: String,
    },

    dataShowClear: {
      type: Boolean,
      default: false,
    },

    readonly: {
      type: Boolean,
      default: false,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    noControl: {
      type: Boolean,
      default: false,
    },

    dataIcon: {
      type: String,
    },

    titleMaxWidth: {
      type: String
    }
  },

  computed: {
    icon() {
      if (this.readonly) return;

      if (this.dataShowClear) return "mdi-close";

      return (
        this.dataIcon || (this.hidden ? "mdi-chevron-down" : "mdi-chevron-up")
      );
    },

    classes() {
      return {
        "btn-secondary": this.border && !this.buttonGradient,
        "btn-stretch": this.border || this.buttonGradient,
      };
    },

    styles() {
      return {
        "font-size": this.dataFontSize ? this.dataFontSize : null,
        "max-width": this.titleMaxWidth ? this.titleMaxWidth : null
      };
    },    

    buttonWrapperClass() {
      return {
        "btn-gradient": this.buttonGradient,
      };
    },

    menuStyles() {
      return {
        padding: this.menuPadding ? this.menuPadding : null,
        width: this.menuWidth,
        height: this.menuHeight,
      };
    },
  },

  methods: {
    click() {
      if (this.disabled) {
        return;
      }

      if (!this.readonly) this.hidden = !this.hidden;

      if (this.hidden) {
        this.$emit("hidden");
      } else {
        this.$emit("opened");
      }
    },

    checkOutsideClick(evt) {
      const notAtButton = evt.target !== this.$refs.button;
      const notAtIcon = evt.target !== this.$refs.icon;
      const notAtBody =
        evt.target !== this.$refs.body && !this.$refs.body.contains(evt.target);

      if (notAtButton && notAtIcon && notAtBody) {
        this.hidden = true;
        this.$emit("hidden");
      }

      evt.stopPropagation();
    },

    clear(evt) {
      if (this.disabled) {
        return;
      }

      if (!this.dataShowClear) return;

      evt.stopPropagation();
      this.$emit("clear");
    },

    close() {
      this.hidden = true;
    },
  },

  mounted() {
    window.addEventListener("mouseup", this.checkOutsideClick);
  },

  destroyed() {
    window.removeEventListener("mouseup", this.checkOutsideClick);
  },

  mixins: [vModel, dropdownMenuProps, dropdownButtonProps],
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.dropdown {
  position: relative;

  .dropdown-title {
    margin: 0;
    overflow-x: hidden;
    text-overflow: ellipsis;
  }

  .dropdown-img {
    width: 20px;
    height: 20px;
    margin-right: 10px;
    margin-bottom: 4px;
  }

  &-btn {
    display: flex;
    align-items: center;
    color: $grey-4;
    padding: 4px 18px;
    white-space: nowrap;

    .mdi {
      margin-left: 2px;
      font-size: 20px;
    }
  }

  &-menu {
    z-index: 10;
    overflow-y: scroll;
    position: absolute;
    top: 70%;
    right: 50%;
    transform: translateX(50%);
    max-height: 500px;

    padding: 10px 20px;
    background-color: $white;
    border-radius: 20px;
    border: 1px solid $grey-2;
  }

  &.dropdown_disabled {
    .dropdown-btn {
      background: #f2f2f2;
    }
  }

  &[no-border] {
    .dropdown-btn {
      border: none;
    }
  }

  &[small] {
    .dropdown-title {
      font-size: 14px;
    }

    .dropdown-btn {
      padding-top: 0;
      padding-bottom: 0;
    }
  }
}
</style>
